import { render } from "./CollaborationContractProposal.vue.js?vue&type=template&id=3132862b&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationContractProposal.vue?vue&type=template&id=3132862b&scoped=true"
import script from "./CollaborationContractProposal.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationContractProposal.vue?vue&type=script&lang=js"
export * from "./CollaborationContractProposal.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationContractProposal.vue?vue&type=script&lang=js"

import "./CollaborationContractProposal.vue.scss?vue&type=style&index=0&id=3132862b&scoped=true&lang=scss!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationContractProposal.vue?vue&type=style&index=0&id=3132862b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3132862b"],['__file',"src/Web/scripts/components/CollaborationContractProposal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3132862b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3132862b', __exports__)) {
    api.reload('3132862b', __exports__)
  }
  
  module.hot.accept("./CollaborationContractProposal.vue.js?vue&type=template&id=3132862b&scoped=true!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaborationContractProposal.vue?vue&type=template&id=3132862b&scoped=true", () => {
    api.rerender('3132862b', render)
  })

}


export default __exports__